import { render, staticRenderFns } from "./Carousel.vue?vue&type=template&id=02e35629&scoped=true&"
import script from "./carousel.ts?vue&type=script&lang=ts&"
export * from "./carousel.ts?vue&type=script&lang=ts&"
import style0 from "./Carousel.vue?vue&type=style&index=0&id=02e35629&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "02e35629",
  null
  
)

export default component.exports